import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'maplibre-gl/dist/maplibre-gl.css';
import { App } from './App.js';
import { tokenAusAdresseUebernehmen } from './auth/linkToken.js';
import './index.css';

// Anmeldelink: Token vor dem ersten Rendern aus Adresszeile und Verlauf nehmen
tokenAusAdresseUebernehmen();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
